interface ProductItemProps {
  product: {
    id: number;
    title: string;
    price: number;
    image: string;
  };
}

export const ProductItem = ({ product }: ProductItemProps) => {
  return (
    <>
      <div className="flex flex-col justify-items-start bg-white shadow-md rounded-md pb-2 text-sm">
        <img
          className="block object-cover object-center w-full h-32 sm:h-40 md:h-44 rounded-t-md"
          src={product.image}
          alt={product.title}
        />
        <h4 className="p-1">{product.title}</h4>
        <div className="p-1">
          <h4 className="font-semibold mb-2">
            ${(product.price - product.price * 0.2).toFixed(2)}
            <del className="text-gray-500 font-light ml-1">
              ${product.price}
            </del>
            <span className="text-red-500 ml-1">20%</span>
          </h4>
          <div className="text-center justify-items-end">
            <button className="bg-teal-500 text-white px-2 py-1 rounded-md text-sm">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
